import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiKeyValue } from '@app/packages/api/v2/types/entities'

export const getKeyValuesById = (id: string) =>
  createApiAction('getKeyValuesById', dispatch => dispatch<{ data: ApiKeyValue }>({ method: 'GET', endpoint: urlEscaped`/api/v2/key_values/${id}` }))

export const putKeyValuesById = (id: string, body: { value: string }) =>
  createApiAction('putKeyValuesById', dispatch =>
    dispatch<unknown>({ method: 'PUT', endpoint: urlEscaped`/api/v2/key_values/${id}`, body: JSON.stringify(body) })
  )
